import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

interface DeleteUserParams {
  id: string
  type?: 'user' | 'invitation'
}

export function useDeleteUserMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, type }: DeleteUserParams) => {
      const query: Record<string, string | number | boolean> = {}
      if (type) query.type = type

      await fetchApi({
        endpoint: `/api/users/delete/${encodeURIComponent(id)}`,
        method: 'DELETE',
        query,
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['users', 'list'] })
    },
  })
}
